import { defineComponent, reactive } from 'vue';
export default defineComponent(() => {
  let user = reactive({});
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      user = JSON.parse(userStr);
    } catch (e) {
      //
    }
  }
  return {
    user,
    companybg: require('../assets/imgs/companybg.png'),
    personbg: require('../assets/imgs/personbg.png')
  };
});